// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content{\n  padding: 20px;\n}\n\n.content__title{\n  font-size: 32px;\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
